import React, { useMemo } from "react";
import { TextField, Typography, Tooltip } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import Autocomplete from "@material-ui/lab/Autocomplete";

/**
 * Convierte un objeto plano (ej: { 1: "A", 2: "B" }) a array de opciones [{ label, value }]
 */
const objectToOptions = (obj) =>
  Object.keys(obj).map((key) => ({
    value: key,
    label: obj[key] ?? "",
  }));

const SelectorGenerico = ({
  autoCompleteStyle,
  label = "Seleccionar",
  value,
  onChange,
  inputValue,
  onInputChange,
  options = [],
  plainObject = null,
  getOptionLabel = (option) => (option?.label ? option.label : ""),
  noOptionsText = "No hay opciones",
  error = false,
  classNameDiv,
  open,
  onOpen,
  onClose,
  onHighlightChange,
  placeholder = "Buscar...",
  tieneTooltip = false,
  titleTooltip = "",
  disabled = false,
  getOptionDisabled = () => false,
  styleDiv = { display: "flex", alignItems: "center", marginBottom: 4 },
}) => {
  // Memoizar opciones para evitar recomputaciones
  const finalOptions = useMemo(() => {
    return plainObject ? objectToOptions(plainObject) : options;
  }, [plainObject, options]);

  // Memoizar el valor seleccionado para evitar búsquedas repetidas
  const resolvedValue = useMemo(() => {
    return typeof value === "string"
      ? finalOptions.find((opt) => opt.value === value) || null
      : value || null;
  }, [value, finalOptions]);

  return (
    <div className={classNameDiv}>
      <div style={styleDiv}>
        <Typography variant="subtitle1">{label}</Typography>
        {tieneTooltip && (
          <Tooltip
            title={<span style={{ fontSize: "0.8rem" }}>{titleTooltip}</span>}
          >
            <InfoIcon
              fontSize="small"
              style={{ color: "rgba(0, 0, 0, 0.54)" }}
            />
          </Tooltip>
        )}
      </div>
      <Autocomplete
        className={autoCompleteStyle}
        open={open}
        onOpen={onOpen}
        onClose={onClose}
        options={finalOptions}
        getOptionLabel={getOptionLabel}
        value={resolvedValue}
        onChange={onChange}
        inputValue={inputValue}
        onInputChange={onInputChange}
        onHighlightChange={onHighlightChange}
        noOptionsText={noOptionsText}
        getOptionDisabled={getOptionDisabled}
        autoHighlight
        autoSelect
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            style={{ minHeight: "3rem" }}
            placeholder={placeholder}
            variant="outlined"
            fullWidth
            size="small"
            error={error}
            disabled={disabled}
          />
        )}
      />
    </div>
  );
};

// Evita renders innecesarios si las props no cambian
export default React.memo(SelectorGenerico);
